import MissionCtrl from "./components/MissionCtrl";
import "./index.css";

export function App() {
  return <MissionCtrl />;
}

export default App;
